import loader from "../../../Util/loader";
import api from "../api";
import {bootstrapDangerGrowl as errorGrowl} from "../../../Util/growler";

export default {
    methods: {
        cloneJourney(journeyId) {
            loader.show();

            api.cloneJourney(journeyId).then(
                ({id: newJourneyId}) => window.location.href = api.getViewJourneyUrl(newJourneyId),
                err => {
                    loader.hide();
                    errorGrowl(err);
                }
            )
        }
    }
}